import { deserialize, serialize } from "serializr";

import _axiosInstance from "../../interceptor/_axiosInstance";

import { FilterSalesReport,SalesReportModel } from "../../models/ReportsModel/sales.model";
import { SALES_REPORT,DOWNLOAD_SALES_REPORT  } from "../../routes/routeConstants/apiRoutes";
import { defaultSalesReports } from "../../shared/utils/filter";


export default class SaleReportssService {

    static fetchSaleReports(
        data: FilterSalesReport,
        onSuccess: (data: SalesReportModel[]) => void,
        onError: Function,
        onFinal: () => void
    ) {
        const payload = serialize(FilterSalesReport, { ...defaultSalesReports, ...data })      
        delete payload.BoardId;
        return _axiosInstance.post(SALES_REPORT,null, { params: payload })
            .then(response => {
                const data = deserialize(SalesReportModel, response?.["data"]) as SalesReportModel[];
                onSuccess(data);
            })
            .catch(error => {
                onError(error)
            })
            .finally(onFinal)
    }

    static downloadSaleReports(
        data: FilterSalesReport,
        onSuccess: (value: any) => void,
        onError: Function,
        onFinal: () => void
    ) {
        const payload = serialize(FilterSalesReport, { ...defaultSalesReports, ...data })
        delete payload.BoardId;
        return _axiosInstance.post(DOWNLOAD_SALES_REPORT,null, { params: payload })
            .then((response) => new Blob([response.data]))
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    `Report.csv`,
                );
                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                link.parentNode?.removeChild(link);

                onSuccess("Download");
            })
            .catch((e) => {
                onError(e);
            })
            .finally(onFinal);
    }
}